export default "/images/bf0a24686d0bfe7ce3512607341cc866.avif";